import {
    darken,
    makeStyles,
    Theme,
} from '@material-ui/core/styles';

import {
    primaryBackgroundButtonColor,
    primaryTextButtonColor,
    secondaryBackgroundButtonColor,
    secondaryTextButtonColor,
    silverSand,
    white,
} from 'styles/abstract/variables';

import {
    BUTTON_THEME,
    BUTTON_COLOR_THEME,
} from 'common/components/Button';

type Props = {
    colorTheme?: BUTTON_COLOR_THEME;
    theme?: BUTTON_THEME;
    isOrderPanel?: boolean;
};

const colors = {
    gray: {
        background: secondaryBackgroundButtonColor,
        borderColor: '',
        text: secondaryTextButtonColor,
    },
    outlinedPrimary: {
        background: 'rgba(255, 255, 255, 0.4)',
        borderColor: '',
        text: primaryBackgroundButtonColor,
    },
    darkgray: {
        background: silverSand,
        borderColor: '',
        text: white,
    },
};

export const makeButtonStyles = makeStyles((materialTheme: Theme) => ({
    root: ({ colorTheme, theme, isOrderPanel = false, }: Props): any => {
        const chosenColor = colors[colorTheme as keyof typeof colors];

        const styles = {
            base: {
                backgroundColor: chosenColor?.background || primaryBackgroundButtonColor,
                borderRadius: 0,
                borderColor: chosenColor?.borderColor || primaryBackgroundButtonColor,
                color: chosenColor?.text || primaryTextButtonColor,
                textTransform: 'none',
                minHeight: !isOrderPanel ? '36px' : 'inherit',

                '&:hover': {
                    backgroundColor: darken(
                        chosenColor?.background || primaryBackgroundButtonColor,
                        0.1,
                    ),
                },

                [materialTheme.breakpoints.down('xs')]: !isOrderPanel ? {
                    fontSize: '0.75rem',
                    padding: materialTheme.spacing(0.25, 0.5),
                } : {},
            },

            clearFilters: {
                marginTop: materialTheme.spacing(2),
            },
        };

        return Object
            .assign(
                styles.base,
                theme === BUTTON_THEME.CLEAR_FILTERS && styles.clearFilters,
            );
    },

    label: ({ theme, }: Props): any => {
        const styles = {
            base: {},
            clearFilters: {
                fontSize: 11,
            },
        };

        return Object
            .assign(
                styles.base,
                theme === BUTTON_THEME.CLEAR_FILTERS && styles.clearFilters,
            );
    },

}));
